"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Session = void 0;
const uuid_1 = require("uuid");
const index_1 = __importDefault(require("../config/index"));
const local_data_1 = require("../helpers/local-data");
class Session {
    constructor() {
        Object.defineProperty(this, "sessionData", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
    static load() {
        const session = new Session();
        session.loadOrCreateSession();
        return session;
    }
    get id() {
        this.refresh();
        return this.sessionData.id;
    }
    get expires() {
        return this.sessionData.expires;
    }
    get expired() {
        return Date.now() > this.sessionData.expires;
    }
    get elapsedMS() {
        return Date.now() - this.sessionData.created;
    }
    refresh() {
        if (!this.expired) {
            this.sessionData.updated = Date.now();
            this.sessionData.expires = this.expiryFromNow;
        }
        else {
            this.sessionData.updated = Date.now();
            this.sessionData.created = Date.now();
            this.sessionData.id = (0, uuid_1.v4)();
            this.sessionData.expires = this.expiryFromNow;
        }
        this.storedData = this.sessionData;
    }
    loadOrCreateSession() {
        var _a;
        this.sessionData = (_a = this.storedData) !== null && _a !== void 0 ? _a : {
            id: (0, uuid_1.v4)(),
            expires: this.expiryFromNow,
            created: Date.now(),
            updated: Date.now(),
        };
    }
    set storedData(session) {
        if (local_data_1.LocalData.hasStorage) {
            local_data_1.LocalData.writeStorage(local_data_1.StorageKeys.sessionId, session);
        }
    }
    get storedData() {
        return local_data_1.LocalData.hasStorage
            ? local_data_1.LocalData.readStorage(local_data_1.StorageKeys.sessionId)
            : null;
    }
    get expiryFromNow() {
        const expiry = new Date();
        expiry.setTime(expiry.getTime() + index_1.default.sessionExpiryTimeMs);
        return expiry.getTime();
    }
}
exports.Session = Session;
